(() => {
  const modal = document.getElementById('videoModal');
  const player = document.getElementById('modalVideo');
  const close = document.getElementById('modalClose');

  document.querySelectorAll('.video-card').forEach(btn => {
    btn.addEventListener('click', () => {
      player.src = btn.dataset.video;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      player.play().catch(() => {});
    });
  });

  function closeModal() {
    player.pause();
    player.removeAttribute('src');
    player.load();
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  close.addEventListener('click', closeModal);
  modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(); });
})();